<template>
  <svg :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0167 2H8.15C7.20583 2 6.43333 2.7725 6.43333 3.71667V17.45C6.43333 18.3942 7.20583 19.1667 8.15 19.1667H18.45C19.3942 19.1667 20.1667 18.3942 20.1667 17.45V7.15L15.0167 2ZM18.45 17.45H8.15V3.71667H14.1583V8.00833H18.45V17.45ZM4.71667 5.43333V20.8833H18.45V22.6H4.71667C3.7725 22.6 3 21.8275 3 20.8833V5.43333H4.71667Z"
      fill="currentColor" />
  </svg>
</template>
<script>
  export default {
    props: {
      size: {
        type: Number,
        default: 24,
      },
    },
    name: "pagesIcon",
  };
</script>
